
import React, { useState, useEffect } from "react";
import {
    Box,
    Typography,
    Toolbar,
    InputAdornment,
    IconButton,
    Menu,
    MenuItem,
    Table,
    TableBody,
    TableCell,
    TableFooter,
    TableSortLabel,
    TableContainer,
    TableHead,
    TableRow,
    TablePagination,
    Button,
    Dialog,
    DialogTitle,
    DialogContentText,
    DialogActions,
    DialogContent,
    Slide,
    Paper,
    FormControl,
    InputLabel,
    Select,
    Autocomplete,
    Stack,
    Badge,
    TextField,
    Tooltip,
    Divider
} from "@mui/material";
import {ContainerClasses} from '../../themes/containerClasses';
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import MenuIcon from "@mui/icons-material/Menu";
import AccountCircle from "@mui/icons-material/AccountCircle";
import PushPinIcon from "@mui/icons-material/PushPin";
import BarChartIcon from "@mui/icons-material/BarChart";
import PieChartIcon from "@mui/icons-material/PieChart";
import SpeedIcon from "@mui/icons-material/Speed";
import TimelineIcon from "@mui/icons-material/Timeline";
import ViewKanbanIcon from "@mui/icons-material/ViewKanban";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CheckIcon from "@mui/icons-material/Check";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import ListIcon from "@mui/icons-material/List";
import {useTheme} from '@mui/material/styles';
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import {SearchFieldComponent} from "../../components/searchField/SearchField";
import {BarChartConfigurationMenuComponent} from "./BarChartConfigurationMenu";
import {PinConfigurationComponent} from "./PinConfiguration";
import {useSnackbar} from "notistack";
import { formatDate, formatDatetime } from "../../utils/dateFunctions";
import {Link, useParams} from 'react-router-dom';
import {getAppName, getObjectName } from "../../utils/helperRouter";
import Config from "../../config";
import { useAuth } from "../../hooks/useAuth";
import {ListViewModel,
        ListViewColumnModel} from '../../models/models';
import {ListConfigurationModel,
        ListViewConfigurationModel} from '../../models/modelsListConfiguration';
import {BaseSuccessModel} from '../../models/modelsException';
import {PinModel,
        ListViewUIPreferenceModel,
        ListViewUIPreferenceJSON,
        BarChartUIPreferenceModel} from '../../models/modelsUserConfiguration';
import {upsertPin, deletePin} from "../../services/userConfigurationApi";


export const ListConfigurationComponent: React.FC<{
  listView: ListViewModel,
  listViewConfig: ListViewConfigurationModel,
  setBarChartConfig: (listView: ListViewModel, barChartGroups: BarChartUIPreferenceModel[]) => void
  setListViewConfig: (listView: ListViewModel, listViewConfig: ListViewConfigurationModel) => void
}> = ({
  listView,
  listViewConfig,
  setBarChartConfig,
  setListViewConfig
}) => {

  const styles = ContainerClasses();

  let {appName, objectName, recordUuid} = useParams();
  const {accessToken, onInvalidToken} = useAuth();

  const { enqueueSnackbar } = useSnackbar();

  const [anchorElBarChartMenu, setAnchorElBarChartMenu] = React.useState<null | HTMLElement>(null);

  useEffect(() => {
  }, [])

  const handleOpenBarChartMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElBarChartMenu(event.currentTarget);
  };
  const handleCloseBarChartMenu = () => {
    setAnchorElBarChartMenu(null);
  };

  const submitListViewConfig = () => {
    setListViewConfig(listView, listViewConfig)
  }

  const handleKanban = () => {
     enqueueSnackbar('Kanban not yet implemented', {
       variant: "error",
     });
  }

  const handleBarChart = () => {
     enqueueSnackbar('BarChart not yet implemented', {
       variant: "error",
     });
  }

  const handleTimeline = () => {
     enqueueSnackbar('Timeline not yet implemented', {
       variant: "error",
     });
  }

  const handlePieChart = () => {
     enqueueSnackbar('PieChart not yet implemented', {
       variant: "error",
     });
  }

  const handleGaugeChart = () => {
     enqueueSnackbar('GaugeChart not yet implemented', {
       variant: "error",
     });
  }

  const getRank = () => {
    if(listView.user_preference &&
       listView.user_preference.IsPinned_sys){
         return listView.user_preference?.Rank_sys
       }
    return null
  }

  return (
    <Box sx={{flex: 1,
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%"}}
    >
    <BarChartConfigurationMenuComponent
      listView={listView}
      onClose={handleCloseBarChartMenu}
      anchorEl={anchorElBarChartMenu}
      onSubmit={setBarChartConfig}
    />
    <Stack direction="row" spacing={1}>
      <PinConfigurationComponent
         listView={listView}
      />

      <Tooltip key={'list'} title={'List View'}>
        <span>
          <IconButton
            size="small"
            onClick={submitListViewConfig}
            disabled={listView.getDisplayType() === 'List'}
          >
            <ListIcon
              fontSize="small"
              color={listView.getDisplayType() === 'List' ? 'primary': 'inherit'}
            />
          </IconButton>
        </span>
      </Tooltip>

      <Tooltip key={'kanban'} title={'Kanban View'}>
        <span>
          <IconButton
            size="small"
            onClick={() => handleKanban()}
            disabled={listView.getDisplayType() === 'Kanban'}
          >
            <ViewKanbanIcon
              fontSize="small"
              color={listView.getDisplayType() === 'Kanban' ? 'primary': 'inherit'}
            />
          </IconButton>
        </span>
        </Tooltip>
    </Stack>

    <Stack direction="row" spacing={1}>

      <Tooltip key={'bar-chart'} title={'Bar Chart'}>
        <span>
          <IconButton
            size="small"
            onClick={handleOpenBarChartMenu}
            disabled={false}
          >
            <BarChartIcon
              fontSize="small"
              color={listView.getDisplayType() === 'BarChart' ? 'primary': 'inherit'}
            />
          </IconButton>
        </span>
      </Tooltip>

      <Tooltip key={'timeline'} title={'Timeline View'}>
        <span>
          <IconButton
            size="small"
            onClick={() => handleTimeline()}
            disabled={listView.getDisplayType() === 'Timeline'}
          >
            <TimelineIcon
              fontSize="small"
              color={listView.getDisplayType() === 'Timeline' ? 'primary': 'inherit'}
            />
          </IconButton>
        </span>
      </Tooltip>

      <Tooltip key={'pie-chart'} title={'Pie Chart'}>
        <span>
          <IconButton
            size="small"
            onClick={() => handlePieChart()}
            disabled={listView.getDisplayType() === 'PieChart'}
          >
            <PieChartIcon
              fontSize="small"
              color={listView.getDisplayType() === 'PieChart' ? 'primary': 'inherit'}
            />
          </IconButton>
        </span>
      </Tooltip>


      <Tooltip key={'gauge-chart'} title={'Gauge Chart'}>
        <span>
          <IconButton
            size="small"
            onClick={() => handleGaugeChart()}
            disabled={listView.getDisplayType() === 'GaugeChart'}
          >
            <SpeedIcon
              fontSize="small"
              color={listView.getDisplayType() === 'GaugeChart' ? 'primary': 'inherit'}
            />
          </IconButton>
        </span>
      </Tooltip>

    </Stack>

    </Box>
  );

};
